import {RichTextField} from '@hconnect/common/components/formFields'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {COMMON_SHIFT_EVENT_WIDGET_NAMESPACE} from '../../consts'

type Props = {
  'data-test-id'?: string
  current?: string
  errorCode?: string
  onChange: (next: string) => void
  required?: boolean
  disabled?: boolean
  enableSpellChecking?: boolean
}

export const EventDescriptionBox: React.FC<Props> = ({errorCode, ...props}: Props) => {
  const {t} = useTranslation(COMMON_SHIFT_EVENT_WIDGET_NAMESPACE)

  return (
    <RichTextField
      {...props}
      label={t('shiftEvent.label.description')}
      pressAndHoldRecordLabel={t('shiftEvent.label.pressAndHoldRecord')}
      errorCodeLabel={errorCode ? t(errorCode) : undefined}
    />
  )
}
